class ContentListSwiper {
  constructor(el,opt){
    this.el = el;
  }
  event(){
    const contentListSwiper = '.js-content-list-swiper';
    const thisSwiper = new Swiper(contentListSwiper, {
      loop: true, // ループの有効化
      allowTouchMove: false,
      effect: 'fade',
      autoplay: { // 自動再生させる
        delay: 5000, // 次のスライドに切り替わるまでの時間（ミリ秒）
      },
    });
  }

}
